<!--Basics of this component
1) This will be a sub compnente of the Project Outcome  CRUD component
2) Validates name is longer than 3 chareters
3) Posts new name to server 
4) Updates state for this project aliases
5) Handels errors from server (duplicate name or 500 most likley)
-->

<template>
  <div>
    <b-container style="padding-bottom:25px">
      <b-row>
        <b-col cols="12">
          <p style="font-weight:bold">Edit or Delete Outcome</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group
            v-if="outcome"
            id="Outcome-1"
            label="Project Outcome"
            label-for="input-1"
            :invalid-feedback="invalidFeedback"
            :valid-feedback="validFeedback"
            :state="state.outcomeName"
          >
            <b-form-input
              id="input-1"
              autocomplete="off"
              v-model="outcomeName"
              :state="state.outcome"
              placeholder="Add a project outcome"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            v-if="outcome"
            id="Outcome-2"
            label="Project Outcome Description"
            label-for="input-2"
            :invalid-feedback="invalidFeedback"
            :valid-feedback="validFeedback"
            :state="state.outcomeFullName"
          >
            <b-form-textarea
              id="input-1"
              autocomplete="off"
              v-model="outcomeFullName"
              :state="state.outcomeFullname"
              placeholder="Add a project outcome"
              rows="5"
              max-rows="10"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-v="start" align-h="end">
        <b-col cols="6"> </b-col>
        <!-- cancel button navigate back to Contact Crud Componet-->
        <b-col cols="2">
          <b-button style="float:right" @click="navBack()">Cancel</b-button>
        </b-col>
        <b-col cols="2">
          <b-button
            variant="danger"
            :disabled="enableDelete"
            style="float:right"
            @click="deleteOutcome()"
            >Delete</b-button
          >
        </b-col>

        <b-col cols="2">
          <b-button
            variant="primary"
            :disabled = "enableOK"
            v-if="state"
            style="float:right"
            @click="updateOutcome()"
            >OK</b-button
          >
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  computed: {
    project() {
      return this.$store.getters.project;
    },
    outcomeId() {
      // HOW TOO read data from the objects included in the route that got us here
      return this.$route.params.outcomeId;
    },
    state() {
      {
      var outcomeName = null;
      var outcomeFullName =null;
      
      if (this.outcomeName != null && this.outcomeName.length < 3) {outcomeName = false;}
      if (this.outcomeName != null && this.outcomeName.length >= 3) {outcomeName = true;}
      if (this.outcomeFullName != null && this.outcomeFullName.length < 3) {outcomeFullName = false;}
      if (this.outcomeFullName != null && this.outcomeFullName.length >= 3) {outcomeFullName = true;}
      return{
        'outcomeName':outcomeName,
        'outcomeFullName':outcomeFullName
      }
    }
    },
    urlPrefix() {
      return this.$store.getters.urlPrefix;
    },
    enableOK(){
      if (this.state.outcomeName == true && this.state.outcomeFullName == true){return false}else{return true}

    },
  },
  mounted() {
    this.outcome = this.project.outcomes[this.outcomeId];
    this.outcomeFullName = this.outcome.outcomeFullname;
    this.outcomeName = this.outcome.outcome;
    if (this.outcome.outcomeUseCount > 0) {
      this.enableDelete = true;
    } else {
      this.enableDelete = false;
    }
  },
  data() {
    return {
      //alias: this.project.aliases[this.aliasId],
      outcome: null,
      outcomeName: null,
      outcomeFullName: null,
      invalidFeedback: "Outcome names need to be 3 or more characters long",
      validFeedback: "Thanks !",
      enableDelete: null
    };
  },
  methods: {
    deleteOutcome() {
      // this called from the delete button which is disables if the alias has any project activities linked to it.
      const payload = {
        url: this.urlPrefix + "api/projectOutcomes/" + this.outcome.id + "/",
        mutationName: "projectOutcomeDelete",
        deletedId: this.outcome.id,
        data: { projectId: this.project.id, id: this.outcome.id }
      };
      //eslint-disable-next-line no-console
      // console.log('deleted id is ', payload.deletedId)
      this.$store.dispatch("genericDeleteApiCall", payload);
      this.navBack();
    },
    updateOutcome() {
      if (this.outcomeName == this.outcome.outcome && this.outcomeFullName == this.outcome.outcomeFullname) {
        // no edit has been made but the user has pressed ok
        // just nav back otherwise a duplicte error will be thrown
        this.navBack();
        return;
      }
      const payload = {
        url: this.urlPrefix + "api/project/" + this.project.id + "/",
        mutationName: "project",
        data: {
          projectId: this.project.id,
          outcomes: [
            {
              id: this.outcome.id,
              outcome: this.outcomeName,
              outcomeFullname: this.outcomeFullName
            }
          ]
        }
      };
      this.$store.dispatch("genericUpdateApiCall", payload);
      this.navBack();
    },

    navBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style></style>
